function Promotion(props) {
  return <h1>Khuyến mãi</h1>;
}

export default Promotion;
